import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Core
import {withStyles, makeStyles} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

// Material-UI Lab
// import ToggleButton from '@material-ui/lab/ToggleButton'

// Material-UI Icon


// Custom Component
import {redColor, oceanBlueColor, grayColor, blackColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import useLoading from "../Loading/useLoading"
import DrawingCard from "../DrawingCard/DrawingCard"

// Custom Style
import unpublishStyle from '../../styles/jss/components/drawingRegister/unpublishStyle'

// Fetch Data
import {getUnpublishPacks} from '../../dataSource/drawingRegister'

// Custom Style (Typography)
const MessageTypography = withStyles({
	root: {
		"fontSize": 18,
		"fontWeight": 400,
		"color": redColor[5]
	},
}) (Typography)


const useStyles = makeStyles(theme => unpublishStyle(theme))

const Unpublish = props => {
	const {openUnpublishDetail, refashUnpublishRecord} = props
	const store = require('store')
	const classes = useStyles()
	const dispatch = useDispatch()
	
	const [unpublishPacks, setUnpublishPacks] = useState(null)

	// Loading 
	const [getCardLoading, getCardShowLoading, getCardHiddenLoading] = useLoading()

	// Redux Data
	// const unpublishPacksRedux = useSelector(state => state.unpublishPacksRedux)


	// Dialog Contral
	// const [unpublishDetailDialogOpen, setUnpublisDetailhDialogOpen] = useState(false)


	// // Dialog open and close contral
	// const unpublishDetailDialogHandleOpen = () => {
	// 	setUnpublisDetailhDialogOpen(true)
	// }

	// const unpublishDetailDialogHandleClose = () => {
	// 	setUnpublisDetailhDialogOpen(false)
	// }


	// Dialog button declaration
	const unpublishDialogBtn = [
		// {
		// 	buttonName: "Annotation Publish",
		// 	buttonFunction: annotationPublishActionHandleOpen,
		// 	chooseFile: false
		// },
	]


	useEffect(() => {
		getCardShowLoading()   // Display the Loading image
		getUnpublishPacks().then(res => {
			setUnpublishPacks(res.data)
			dispatch({
				type: "ADD_UNPUBLISH_PACKS",
				data: res.data
			})

			getCardHiddenLoading()   // Hidden the Loading image
		})

	}, [refashUnpublishRecord])


	return (
		// console.log("Unpublish Packs Data | Variable: unpublishPacks (unpublished.js)"),
		// console.log(unpublishPacks),

		// console.log("Unpublish Packs Data (Redux) | Variable: unpublishPacksRedux (unpublished.js)"),
		// console.log(unpublishPacksRedux),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			{/* <div>
				<FullScreenDialog
					open={unpublishDetailDialogOpen}
					dialogTitle={"Un-Publish Detail"}

					formContent={
						// <DrawingDetail
						// 	drawingDetailRecord={drawingDetailRecord}
						// />
						<div>Detail</div>
					}

					button={unpublishDialogBtn}
					handleClose={unpublishDetailDialogHandleClose}
				/>
			</div> */}

			<div>
				{getCardLoading}
				{
					unpublishPacks && unpublishPacks.length > 0 ?
						<DrawingCard
							cardSourceData = {unpublishPacks}
							cardButtonAction = {openUnpublishDetail}
						/>
					:
						<div className={classes.messageArea}>
							<MessageTypography>No Un-published Record</MessageTypography>
						</div>
				}
			</div>
		</Fragment>
	)
}


export default Unpublish